import { render } from "./AvatarInline.vue?vue&type=template&id=717bf108&scoped=true"
import script from "./AvatarInline.vue?vue&type=script&lang=js"
export * from "./AvatarInline.vue?vue&type=script&lang=js"

import "./AvatarInline.vue?vue&type=style&index=0&id=717bf108&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717bf108"]])

export default __exports__